/* ML-03 · GROUPS & LIFECYCLE
   Groups, and the lifecycle guarantee: nothing a merchant does to a location
   takes attribution, wallet access or issued gift terms away from a customer.
   · L9 group-scoped gift validity */
import { Button, ListRow, Note } from '@/ui'
import { useML } from './EtabShell'

export default function ML03Groupes() {
  const groups = useML().groups
  return (
    <section data-frame="ML-03" style={{ display: 'grid', gap: 14 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
        <h2 className="t-section" style={{ flex: 1 }}>Groupes</h2>
        <Button variant="quiet" size="sm">Nouveau groupe</Button>
      </div>
      <div>
        {groups.map(g => (
          <ListRow key={g.title} title={g.title} meta={g.meta}
            end={<Button variant="ghost" size="sm">gérer</Button>} />
        ))}
      </div>
      <Note tone="candour">
        Ajouter, mettre en pause, transférer, fermer ou archiver un établissement conserve :
        attribution historique, accès portefeuille client, conditions des cadeaux émis.
      </Note>
    </section>
  )
}
